export default __webpack_public_path__ + "static/media/S70.b754af92.png";